import type { DomainManifest } from 'modules/core/lib/manifests/types'
import { CreateTicketActivity } from 'modules/ticketing/activities/CreateTicket'
import { TicketDetailActivity } from 'modules/ticketing/activities/TicketDetail'
import i18n from 'modules/core/lib/i18n'
import { CheckCircleLine } from '@factorialco/f0-react/icons/app'
import { CreateTicketAction } from 'modules/ticketing/lib/oneHandlers/create-ticket'
import { CreateTicketCommentAction } from 'modules/ticketing/lib/oneHandlers/create-ticket-comment'

export const manifest = {
  sidebar: (navigation) => ({
    items: [
      {
        identifier: 'ai_ticketing',
        name: i18n.t('ticketing.sidebar.inbox'),
        factorialOneIcon: CheckCircleLine,
        path: navigation.ticketing.fullPath(),
        group: 'company',
        module: 'ai_ticketing',
        priority: 'low',
      },
    ],
  }),
  one: {
    createActions: {
      ticket: CreateTicketAction,
      ticketComment: CreateTicketCommentAction,
    },
  },
  activities: {
    createTicket: {
      component: CreateTicketActivity,
    },
    viewTicket: {
      component: TicketDetailActivity,
      availableForOne: true,
      guidelines:
        'Opens the ticket detail panel to view and manage an existing ticket. Use when the user wants to view, check, inspect, or manage a specific ticket.',
      params: {
        ticketId: {
          guidelines:
            'The ID of the ticket to view. Use available tools to resolve ticket references to IDs. Never ask the user for the ID directly.',
        },
      },
    },
  },
} as const satisfies DomainManifest
